import { v4 as uuidv4 } from 'uuid';
import { PluginProvider } from '../../../system/providers/plugin';
import DashboardBusinessControlsGridPluginSettings from './DashboardBusinessControlsGridPluginSettings';
import DashboardBusinessControlsPluginView from './DashboardBusinessControlsPluginView';
import i18n from '../../../i18n';

export const DashboardBusinessControlsTab = (): ITab => {
    const t = (value: string) => i18n.t("sidePanel." + value);
    return {
        id: uuidv4(),
        title: t("accounting.submenu.dashboardBusinessControls"),
        view: {
            content:    
            DashboardBusinessControlsGridPluginSettings
                        ?   <PluginProvider plugin={DashboardBusinessControlsGridPluginSettings()}>
                                <DashboardBusinessControlsPluginView gridId={uuidv4()} plugin={DashboardBusinessControlsGridPluginSettings()}/>
                            </PluginProvider>
                        : 
                        <p> Справочник не настроен </p>
        }
    }
}

export default DashboardBusinessControlsTab
